@if (isDark()) {
  <button class="switch-color-scheme" (click)="toggleColorScheme()" matTooltip="Switch to light mode" mat-icon-button>
    <mat-icon>wb_sunny</mat-icon>
  </button>
} @else {
  <button class="switch-color-scheme" (click)="toggleColorScheme()" matTooltip="Switch to dark mode" mat-icon-button>
    <mat-icon>brightness_2</mat-icon>
  </button>
}
